import React from 'react';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

const postOrganisation = ComposedComponent => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  const PostOrganisation = props => <ComposedComponent {...props} />;

  return reduxFetch([
    {
      resource: 'newOrganisation',
      method: 'post',
      request: (values, t) => ({
        url: apiRoutes.postOrganisation(),
        body: values,
        meta: {
          redirectRoute: '/organisations',
          toaster: {
            onSuccessMessage: t('organisationCreated'),
            onErrorMessage: createErrorMessage(t, 'createOrganisationFailed'),
          },
        },
      }),
    },
  ])(PostOrganisation);
};

export default postOrganisation;
